import {
  LANDING_PAGE_HEADING,
  LANDING_PAGE_INFO,
  LANDING_PAGE_INSTRUCTION_HEADING1,
  LANDING_PAGE_INSTRUCTION_HEADING2,
  LANDING_PAGE_INSTRUCTIONS_LIST1,
  LANDING_PAGE_INSTRUCTIONS_LIST2,
  LANDING_PAGE_CONCLUSION,
  GET_STARTED_BUTTON_TEXT,
} from "./Landing.const";
import { Button, Col } from "reactstrap";
import { Heading } from "components/common/Heading";
import { HeadingTag } from "components/common/Heading";

export type LandingProps = {
  onProgress: () => void;
};

export const Landing = (props: LandingProps) => {
  return (
    <>
      <Col className="narrow-container">
        <div className="content-wrapper get-started-page">
          <Heading
            tag={HeadingTag.h1}
            size={1}
            className="zb-heading1 screen-header"
            title={LANDING_PAGE_HEADING}
          ></Heading>
          <p>{LANDING_PAGE_INFO}</p>
          <Heading
            className="section-margin"
            size={5}
            title={LANDING_PAGE_INSTRUCTION_HEADING1}
          />
          <ul>
            {LANDING_PAGE_INSTRUCTIONS_LIST1.map((e: string) => (
              <li key={e}>
                <span>{e}</span>
              </li>
            ))}
          </ul>
          <Heading
            className="section-margin"
            size={5}
            title={LANDING_PAGE_INSTRUCTION_HEADING2}
          />
          <ul>
            {LANDING_PAGE_INSTRUCTIONS_LIST2.map((e: string) => (
              <li key={e}>
                <span>{e}</span>
              </li>
            ))}
          </ul>
          <p className="section-margin">{LANDING_PAGE_CONCLUSION}</p>
          <div className="button-start">
            <Button color="primary" size="lg" onClick={props.onProgress}>
              {GET_STARTED_BUTTON_TEXT}
            </Button>
          </div>
        </div>
      </Col>
    </>
  );
};
